// Theme Colors
// Initially this will be blank. Later on when app is initialized we will assign bootstrap colors to this from CSS variables.
export const $themeColors = {}

// App Breakpoints
// Initially this will be blank. Later on when app is initialized we will assign bootstrap breakpoints to this object from CSS variables.
export const $themeBreakpoints = {}

// APP CONFIG
export const $themeConfig = {
  app: {
    appName: 'MyBulkSMS', // Will update name in navigation menu (Branding)
    // eslint-disable-next-line global-require
    appLogoImage: require('@/assets/images/logo/linksms-big.png'), // Will update logo in navigation menu (Branding)
    appUrl: "https://apiv2client.mascom.linksms.co.bw", // url to the backend.
     //appUrl:'http://127.0.0.1:9100',
    voicePhoneNumber: "+254711082262",
    tylersoftPaymentUri: "https://www.paybills.co.bw:8702/ecommerce/pay",
    tylersoftServiceId:1012,
    tylersoftCountryCode:"BWP",
    tylersoftCallbackUrl:"https://apiv2client.mascom.linksms.co.bw/v1/api/credits/online-payment/callback",

    // appUrl: "http://localhost:8000", // url to the backend.
    // tylersoftPaymentUri: "https://83.143.26.154:8601/ecommerce/pay", // test
    // tylersoftServiceId:1010, // test
    // tylersoftCallbackUrl:"http://localhost:8000/v1/api/credits/online-payment/callback",
  },
  layout: {
    isRTL: false,
    skin: 'light', // light, dark, bordered, semi-dark
    routerTransition: 'zoom-fade', // zoom-fade, slide-fade, fade-bottom, fade, zoom-out, none
    type: 'vertical', // vertical, horizontal
    contentWidth: 'full', // full, boxed
    menu: {
      hidden: false,
      isCollapsed: false,
    },
    navbar: {
      // ? For horizontal menu, navbar type will work for navMenu type
      type: 'sticky', // static , sticky , floating, hidden
      backgroundColor: '', // BS color options [primary, success, etc]
    },
    footer: {
      type: 'static', // static, sticky, hidden
    },
    customizer: false,
    enableScrollToTop: true,
  },
}
